import { render, staticRenderFns } from "./BishanAccount.vue?vue&type=template&id=17547606&scoped=true"
import script from "./BishanAccount.vue?vue&type=script&lang=ts"
export * from "./BishanAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17547606",
  null
  
)

export default component.exports